import React from 'react';

export default function ProductAdditional() {
  return <div></div>;
}
